import { module } from 'angular';

import { CustomFilter, default as customFilterName } from './custom-filter.component.ajs';

export default module('hypervision.skill-view.custom.filter.custom', []).component(customFilterName, new CustomFilter()).name;
